import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaIrrigationApi = createApi({
    reducerPath: "core/measurement/irrigation",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementIrrigationList"],
    endpoints: (builder) =>({
        measurementIrrigationFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementIrrigationList'],
            query: (query = '') => ({
                url: "core/measurement/irrigation" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementIrrigationCreate: builder.mutation({
            invalidatesTags: ['measurementIrrigationList'],
            query: (data)=>({url: "core/measurement/irrigation", method: "POST", data})
        }),
        measurementIrrigationUpdate: builder.mutation({
            invalidatesTags: ['measurementIrrigationList'],
            query: (data)=>({url: "/core/measurement/irrigation/"+data.id, method: "PUT", data})
        }),
        measurementIrrigationDelete: builder.mutation({
            invalidatesTags: ['measurementIrrigationList'],
            query: (id)=>({url: "/core/measurement/irrigation/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementIrrigationFindAllQuery, useMeasurementIrrigationCreateMutation, useMeasurementIrrigationUpdateMutation, useMeasurementIrrigationDeleteMutation } = meaIrrigationApi;
export {meaIrrigationApi};
